import styled from 'styled-components';

export const Content = styled.div`
  height: 100vh;
`;
